import { useEffect, useState } from 'react';
import i18n from '../../../i18n';
import createMainBranch from '../helper/createMainBranch';
import makeBranchItem from '../helper/makeBranchItem';
import getInitialValues from '../helper/getInitialData';
import { END_USERS_ROLE } from '../../../utils/constants';

const BRANCH_NOT_FOUND_FIELD = {
  value: 'branch-not-found',
  label: i18n.t('branch.branchNotFound'),
};

const useBranches = (profileStore, companyData) => {
  const [branches, setBranches] = useState(BRANCH_NOT_FOUND_FIELD);
  const [branchesLoaded, setBranchesLoaded] = useState(false);
  const [initialValues, setInitialValeus] = useState();

  const handleSetBranches = async (company = profileStore.companyData) => {
    const { mainAddress, branch } = company;
    if (!mainAddress) return;
    const mainBranch = createMainBranch(mainAddress);
    const allBranches = [mainBranch, ...branch.map(makeBranchItem), BRANCH_NOT_FOUND_FIELD];
    setBranches(allBranches);
    return allBranches;
  };

  const isEndUser = profileStore.connection === END_USERS_ROLE;

  useEffect(() => {
    const loadData = async () => {
      const initialData = profileStore.profileData;
      if (initialData) {
        const allBranches = await handleSetBranches();
        setBranchesLoaded(true);
        setInitialValeus(getInitialValues(initialData, isEndUser, allBranches, companyData, profileStore.branch));
      }
    };

    loadData();
    // eslint-disable-next-line
  }, []);

  return { branches, setBranches, branchesLoaded, handleSetBranches, initialValues };
};

export default useBranches;
